export const PenIcon = () => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.8681 15.0703L17.0697 15.9435C16.6464 16.4066 16.0722 16.6667 15.4735 16.6667C14.8748 16.6667 14.3006 16.4066 13.8772 15.9435C13.4533 15.4814 12.8791 15.222 12.2806 15.222C11.6821 15.222 11.108 15.4814 10.684 15.9435M3.5 16.6667H4.83666C5.22715 16.6667 5.42238 16.6667 5.60611 16.6226C5.76901 16.5834 5.92473 16.519 6.06758 16.4315C6.22868 16.3327 6.36674 16.1946 6.64285 15.9185L16.6708 5.89063C17.332 5.22936 17.332 4.15723 16.6708 3.49595C16.0095 2.83468 14.9374 2.83468 14.2761 3.49595L4.24815 13.5238C3.97204 13.8 3.83398 13.938 3.73525 14.0991C3.64772 14.242 3.58322 14.3977 3.54411 14.5606C3.5 14.7443 3.5 14.9396 3.5 15.3301V16.6667Z"
      stroke="white"
      strokeWidth="1.30851"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
